import { isTokenAddress, } from "./TokenAddress";
import { isTokenName, } from "./TokenName";

import {
	type TokenName,
	type TokenAddress,
	type TokenDefinition,
	isTokenDefinition,
} from "@bracket/chainography";


/** a token described via label, symbol, address or an instantiated TokenDefinition, empty string for ETH*/
export declare type TokenIdentifier = TokenName | TokenAddress | TokenDefinition | "";

export const isTokenIdentifier = ( value:unknown ): value is TokenIdentifier => {
	return isTokenAddress(value) || isTokenName(value) || isTokenDefinition(value);
}
